
<template>
     <md-card class="m-0">

                      <md-card-header v-if="releaseDate">
                          Industry Market Insights <span class="info">{{ profileMRInfo.period }}</span>
                      </md-card-header>
                            
                             <md-card-content>
          <div class="md-layout">
            <div class="md-layout-item md-medium-size-100 md-size-100 p-0">
              <template v-if="hasMarketTrendData">
                <md-table
                    v-model="penetration"
                    table-header-color="blue"
                    class="profit-and-loss-table"
                >
                  <md-table-row
                      slot="md-table-row"
                      slot-scope="{ item }"
                  >
                    <md-table-cell :md-label="`Market Penetration - ${periodMR}`">{{ item.name }}</md-table-cell>
                    <md-table-cell md-label="Dollars">{{ item.dollars }}</md-table-cell>
                  </md-table-row>
                </md-table>
                <md-table
                    v-model="main"
                    table-header-color="blue"
                    class="profit-and-loss-table"
                >
                  <md-table-row
                      slot="md-table-row"
                      slot-scope="{ item }"
                  >
                    <md-table-cell md-label="Industry Market Overview">{{ item.name }}</md-table-cell>
                    <md-table-cell md-label="Value">{{ item.dollars }}</md-table-cell>
                  </md-table-row>
                </md-table>
              </template>
              <p v-else class="market-trend-pending">
                Market trend data for this industry and area is still being compiled and will
                be available soon.
              </p>
              <md-table
                  v-if="hasIncomeData"
                  v-model="income"
                  table-header-color="blue"
                  class="profit-and-loss-table"
              >
                <md-table-row
                    slot="md-table-row"
                    slot-scope="{ item }"
                >
                  <md-table-cell md-label="Market Area Population and Income">{{ item.name }}</md-table-cell>
                  <md-table-cell md-label="Value">{{ item.dollars }}</md-table-cell>
                </md-table-row>
              </md-table>
              <p v-else class="market-trend-pending">
                Population and income data for this market area is still being compiled and
                will be available soon.
              </p>
            </div>
          </div>
        </md-card-content>
                          </md-card>
                
</template>


<script>
import {NavTabsCard, PulseLoader} from "@/components";
//import {PulseLoader} from '@/components';

import axios from "axios";

export default {
  components: {
     //NavTabsCard,
     //PulseLoader
  },
  data() {
    return {
      months: [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December",
      ],
      filtered_company_profile_list: []
    };
  },
  computed: {

    ifInfo() {
      return this.$store.getters.profileInfo;
    },

     profileInfo() {
      return this.$store.getters.profileInfo;
    },
    profileMRInfo() {
      return this.$store.getters.profileInfo.MR;
    },
    penetration() {
      let penetrationInfo = this.profileMRInfo.penetration;

      let result = Object.keys(penetrationInfo).map((key) => {
        return {
          name: key,
          dollars: penetrationInfo[key],
        };
      });

      return result;
    },
    main() {
      let mainInfo = this.profileMRInfo.main;

      let result = Object.keys(mainInfo).map((key) => {
        return {
          name: key,
          dollars: mainInfo[key],
        };
      });

      return result;
    },
    income() {
      let incomeInfo = this.profileMRInfo.income;

      let result = Object.keys(incomeInfo).map((key) => {
        return {
          name: key,
          dollars: incomeInfo[key],
        };
      });

      return result;
    },
    hasMarketTrendData() {
      // The backend degrades "Annual Market Sales Volume"/"Average Site Sales"/"Average Small
      // Business Sales" to zero (independently of the rest of MR, which can still be
      // structurally present) when this specific area+industry combination has no historical
      // market-trend data computed yet -- see CompanyController::GetProfileDataBackend. Real
      // "$0" values across all three at once would mean literally zero market activity in an
      // area that has companies matching this industry, which doesn't happen in practice, so
      // this is a reliable "not yet available" signal rather than a false positive risk.
      let mainInfo = this.profileMRInfo.main || {};
      let isZero = (v) => v === 0 || v === "0" || v === "$0";
      return !(
        isZero(mainInfo["Annual Market Sales Volume"]) &&
        isZero(mainInfo["Average Site Sales"]) &&
        isZero(mainInfo["Average Small Business Sales"])
      );
    },
    hasIncomeData() {
      // Population/Households/Per Capita Income/Median HH Income come from a genuinely
      // separate lookup (DemogsController::getDemogsAPI, not the same trend-cache row as
      // hasMarketTrendData above) -- checked independently since one can be available without
      // the other.
      let incomeInfo = this.profileMRInfo.income || {};
      let isZero = (v) => v === 0 || v === "0" || v === "$0";
      return !(
        isZero(incomeInfo["Population"]) &&
        isZero(incomeInfo["Households"]) &&
        isZero(incomeInfo["Per Capita Income"]) &&
        isZero(incomeInfo["Median HH Income"])
      );
    },
    releaseDate() {
      return this.$store.getters.releaseDate;
    },
    getFormattedData() {
      let a = {};

      a.company = this.profileInfo.companyTitle;
      a.original_name = "";
      a.infogroup = this.profileInfo.locnum;
      a.unique_id = "";
      a.street = this.profileInfo.street ? this.profileInfo.street : "";
      a.city = this.profileInfo.city ? this.profileInfo.city : "";
      a.state = this.profileInfo.state ? this.profileInfo.state : "";
      a.zip = this.profileInfo.zip ? this.profileInfo.zip : "";
      a.industry_code = this.profileInfo.naics;
      a.industry = this.profileInfo.industry;


      let b = this.profileInfo.businessOwner?this.profileInfo.businessOwner.split(',')[0]:"";
      a.contact_first = b.split(' ')[0];
      a.contact_last = b.split(' ')[1];
      a.phone = this.profileInfo.businessPhone ? this.profileInfo.businessPhone : "";
      a.url = this.profileInfo.businessURL ? this.profileInfo.businessURL : "";
      let g = this.profileInfo.release_id.replace("_", "-01-20");
      const monthNames = ["January", "February", "March", "April", "May", "June",
        "July", "August", "September", "October", "November", "December"
      ];


      a.operation_details = monthNames[new Date(g).getMonth()] + " " + new Date(g).getFullYear();
      a.location_annual_sales = this.profileInfo.bizop['Location Sales'][0];
      a.location_employment = this.profileInfo.bizop['Employment'][0]
      a.corporation_annual_sales = this.profileInfo.bizop['Corporate Sales'][0]
      a.corporation_employment = this.profileInfo.bizop['Corporate Employment'][0]

      a.market_insights_date = monthNames[new Date(g).getMonth()] + " " + new Date(g).getFullYear();
      a.market_industry_code = this.profileInfo.IMRnaics
      a.market_industry = this.profileInfo.IMRindustry
      a.market_area = this.profileInfo['MR']['area']

      a.industry_operations = this.profileInfo['MR']['main']['Industry Operations']
      a.location_sales_rank = this.profileInfo['MR']['main']['Business Sales Rank']
      a.industry_market_sales_volume = this.profileInfo['MR']['main']['Annual Market Sales Volume']
      a.average_site_sales = this.profileInfo['MR']['main']['Average Site Sales']
      a.average_small_business_sales = this.profileInfo['MR']['main']['Average Small Business Sales']

      a.industry_market_sales_per_person = this.profileInfo['MR']['penetration']['Market Sales per Person']
      a.us_industry_sales_per_person = this.profileInfo['MR']['penetration']['US Sales per Person']
      a.opportunity_index_person = this.profileInfo['MR']['penetration']['Opportunity Index Person']
      a.industry_market_sales_per_household = this.profileInfo['MR']['penetration']['Market Sales per Household']
      a.us_industry_sales_per_household = this.profileInfo['MR']['penetration']['US Sales per Household']
      a.opportunity_index_household = this.profileInfo['MR']['penetration']['Opportunity Index Household']

      a.market_area_population = this.profileInfo['MR']['income']['Population']
      a.market_area_households = this.profileInfo['MR']['income']['Households']
      a.per_capita_income = this.profileInfo['MR']['income']['Per Capita Income']
      a.mediab_hh__income = this.profileInfo['MR']['income']['Median HH Income']
      a.business_values_insights_date = monthNames[new Date(g).getMonth()] + " " + new Date(g).getFullYear();

      a.sales_approach_quartile1 = this.profileInfo.multiples.data['Quartile 1']['sales']
      a.sales_approach_median = this.profileInfo.multiples.data['Median']['sales']
      a.sales_approach_quartile3 = this.profileInfo.multiples.data['Quartile 3']['sales']
      a.earnings_approach_quartile1 = this.profileInfo.multiples.data['Quartile 1']['earnings']
      a.earnings_approach_median = this.profileInfo.multiples.data['Median']['earnings']
      a.earnings_approach_quartile3 = this.profileInfo.multiples.data['Quartile 3']['earnings']

      a.if_industry_code = this.profileInfo.naics
      a.if_industry_name = this.profileInfo.industry
      a.if_industry_sales_class = this.profileInfo.IF['sales-class']
      a.financial_insights_date = this.profileInfo.IF['period']

      a.gross_margin_percentage = this.profileInfo.IF.spend['Gross Margin'].percentage;
      a.office_owner_compensation_percentage = this.profileInfo.IF.spend['Officer-Owner-Compensation'].percentage;
      a.depreciation_percentage = this.profileInfo.IF.spend['Depreciation'].percentage;
      a.operating_expense_percentage = this.profileInfo.IF.spend['Operating Expenses'].percentage;
      a.operating_income_percentage = this.profileInfo.IF.spend['Operating Income'].percentage;
      a.after_tax_net_profit_percentage = this.profileInfo.IF.spend['After Tax Net Profit'].percentage;
      a.owner_earnings_percentage = this.profileInfo.IF.spend['Owner Earnings'].percentage;
      a.account_receivable_percentage = this.profileInfo.IF.spend['Accounts Receivable: Total Assets'].percentage;
      a.account_payable_percentage = this.profileInfo.IF.spend['Accounts Payable: TLNW'].percentage;
      a.net_worth_assets_percentage = this.profileInfo.IF.spend['Net Worth: Assets'].percentage;

      a.gross_margin_dollar = this.profileInfo.IF.spend['Gross Margin'].dollar;
      a.office_owner_compensation_dollar = this.profileInfo.IF.spend['Officer-Owner-Compensation'].dollar;
      a.depreciation_dollar = this.profileInfo.IF.spend['Depreciation'].dollar;
      a.operating_expense_dollar = this.profileInfo.IF.spend['Operating Expenses'].dollar;
      a.operating_income_dollar = this.profileInfo.IF.spend['Operating Income'].dollar;
      a.after_tax_net_profit_dollar = this.profileInfo.IF.spend['After Tax Net Profit'].dollar;
      a.owner_earnings_dollar = this.profileInfo.IF.spend['Owner Earnings'].dollar;
      a.account_receivable_dollar = this.profileInfo.IF.spend['Accounts Receivable: Total Assets'].dollar;
      a.account_payable_dollar = this.profileInfo.IF.spend['Accounts Payable: TLNW'].dollar;
      a.net_worth_assets_dollar = this.profileInfo.IF.spend['Net Worth: Assets'].dollar;

      a.account_payable_revenue = this.profileInfo.IF.benchmarks['Accounts Payable: Revenue'];
      a.current_ratio = this.profileInfo.IF.benchmarks['Current Ratio'];
      a.days_payable = this.profileInfo.IF.benchmarks['Days Payable'];
      a.net_working_capital_revenue = this.profileInfo.IF.benchmarks['Net Working Capital Revenue'];
      a.days_receivable = this.profileInfo.IF.benchmarks['Days Receivable'];
      a.interest_coverage = this.profileInfo.IF.benchmarks['Interest Coverage'];
      a.current_liabilites = this.profileInfo.IF.benchmarks['Current Liabilities: NW'];
      a.loans_notes = this.profileInfo.IF.benchmarks['Loans‐Notes Payable: Net Worth'];
      a.modified_z = this.profileInfo.IF.benchmarks['Modified Z Score'];
      a.total_liabilities = this.profileInfo.IF.benchmarks['Total Liabilties: Net Worth'];

      Object.values(a).forEach((element, index) => {
        let b = "";
        if (element && element.includes(',')) {
          b = element.replace(/,/g, ".");
        } else {
          b = element;
        }
        this.filtered_company_profile_list.push(b);
      })
      return this.filtered_company_profile_list;
    },
    getCsvData() {
      let csvData = [
        [
          'Company',
          'Original Name',
          'Infogroup ID',
          'Unique ID',
          'Street',
          'City',
          'State',
          'Zip',
          'Industry Code',
          'Industry',
          'Contact First',
          'Contact Last',
          'Phone',
          'URL',
          'Operation Detail Release',
          'Location Annual Sales',
          'Location Employment',
          'Corporate Annual Sales',
          'Corporate Employment',
          'Market Insights Date',
          'Market Industry Code',
          'Market Industry',
          'Market Area',
          'Industry Operations',
          'Location Sales Rank',
          'Industry Market Sales Volume',
          'Average Site Sales',
          'Average Small Business Sales',
          'Industry Market Sales per Person',
          'US Industry Sales per Person',
          'Opportunity Index',
          'Industry Market Sales per Household',
          'US Industry Sales per Household',
          'Opportunity Index',
          'Market Area Population',
          'Market Area Households',
          'Per Capital Income',
          'Median Household Income',
          'Business Value Insights Date',
          'Sales Approach Quartile1',
          'Sales Approach Median',
          'Sales Approach Quartile3',
          'Earnings Approach Quartile1',
          'Earnings Approach Median',
          'Earnings Approach Quartile3',
          'IF Industry code',
          'IF Industry name',
          'IF Sales class',
          'Financial Insights Date',
          'Gross Margin %',
          'Officer-Owner Compensation %',
          'Depreciation %',
          'Operating Expense %',
          'Operating Income %',
          'After Tax Net Profit %',
          'Owner Earnings %',
          'Accounts Receivable/Total Assets %',
          'Accounts Payable/TLNW %',
          'Net Worth/Assets %',
          'Gross Margin $',
          'Officer-Owner Compensation $',
          'Depreciation $',
          'Operating Expense $',
          'Operating Income $',
          'After Tax Net Profit $',
          'Owner Earnings $',
          'Accounts Receivable/Total Assets $',
          'Accounts Payable/TLNW $',
          'Net Worth/Assets $',
          'Accounts Payable/Revenue',
          'Current Ratio',
          'Days Payable',
          'Net Working Capital/Revenue',
          'Days Receivable',
          'Interest Coverage',
          'Current Liabilities/Net Worth',
          'Loans Notes Payable/Net Worth',
          'Modified Z Score',
          'Total Liabilties/Net Worth'
        ],
      ]

      csvData.push(this.getFormattedData);
      return csvData;
    },
    setLoading(){
      return !this.profileInfo;
    },

    periodIF() {
      return this.ifInfo["IF"]['period'];
    },

    periodMR() {
      return this.ifInfo["MR"]['period'];
    }
  },

  methods: {

     numberWithPoints(x) {
      if (typeof x === 'number') {
        return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
      } else if(x === null){
        return x;
      }else
      {
        return x.replace(/,/g, '.');
      }
    },
    downloadCSVData() {
      let csv = '';
      this.getCsvData.forEach((row) => {
        csv += row.join(',');
        csv += "\n";
      });
      const anchor = document.createElement('a');
      anchor.href = 'data:text/csv;charset=utf-8,' + encodeURIComponent(csv);
      anchor.target = '_blank';
      anchor.download = 'Company Profile.csv';
      anchor.click();
    },
  },
};
</script>
<style lang="scss">
.finanical-insights-body {
  .header-box {
    display: flex;
  }

  .md-collapse-title {
    font-size: 18px;
    font-weight: 500;
    letter-spacing: 0.005em;
    line-height: 16px;
  }

  .md-collapse-content {
    padding: 0;
  }

  .financal-report-col-1 {
    display: flex;
    align-items: center;
  }

  .fi-profile-pdf-box {
    display: flex;
    justify-content: flex-end;
  }

  .profile-title {
    font-size: 24px;
    font-weight: 400;
  }
}

.comp-profile {
  display: flex;
  align-items: start;

  .md-layout {
    text-align: center;

    p {
      margin-left: 0 !important;
    }
  }

  .market-insights {
    p {
      color: #3b7ef1;
    }
  }
}

.table-box-margin {
  .md-layout-item {
    .md-card {
      margin: 15px 0 !important;
    }
  }
}

.fin_tabs {
  width: 100%;

  .md-tabs-navigation {
    display: none;
  }
}

.market-trend-pending {
  padding: 24px 16px;
  text-align: center;
  color: #999;
  font-style: italic;
}
</style>

